var $c83f9725f6024f47$exports = {};
$c83f9725f6024f47$exports = {
    "loading": `Se \xeencarc\u{103}...`,
    "placeholder": `Selecta\u{21B}i\u{2026}`
};


export {$c83f9725f6024f47$exports as default};
//# sourceMappingURL=ro-RO.module.js.map
